"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formTemplateHelper = require("../../helpers/formTemplateHelper");
var _APNumberInput = _interopRequireDefault(require("../common/APNumberInput"));
var _APButton = _interopRequireDefault(require("./../common/APButton"));
var _formValidations = require("../../helpers/formValidations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DepositTemplateFormComponent = function DepositTemplateFormComponent(_ref) {
  var template = _ref.template,
    submitting = _ref.submitting,
    baseClasses = _ref.baseClasses,
    product = _ref.product;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  if (Object.keys(template).length) {
    var viewOnlyForm = Object.values(template).every(function (val) {
      return !!val;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('fields')
    }, viewOnlyForm && /*#__PURE__*/_react["default"].createElement("p", null, t('Please use the following information to make a deposit:')), !template.amount && !template.Amount ? /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
      name: "Amount",
      customClass: baseClasses(),
      labelInInput: product.Product,
      label: t('Amount'),
      decimalPlaces: product.DecimalPlaces,
      validate: [_formValidations.required]
    }) : null, (0, _formTemplateHelper.templateFormRenderer)(template, baseClasses(), {
      t: t
    }, product), !viewOnlyForm && /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
      type: "submit",
      disabled: submitting,
      customClass: baseClasses(),
      styleName: "additive"
    }, submitting ? t('Submitting...') : t('Place Deposit Ticket'))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null);
};
DepositTemplateFormComponent.defaultProps = {
  product: _propTypes["default"].object,
  template: {},
  submitting: false,
  baseClasses: function baseClasses() {}
};
DepositTemplateFormComponent.propTypes = {
  template: _propTypes["default"].object,
  submitting: _propTypes["default"].bool,
  baseClasses: _propTypes["default"].func
};
var _default = exports["default"] = DepositTemplateFormComponent;